<template>
  <app-base-main>
    <template #filter-group>
      <ClaimTotalHead :totalObj="totalObj" type="shipmentClaim" />
      <app-filter-group
        @reset="$gjReset"
        @query="$gjNoticeQuery"
      >
        <gj-country-server-select
            v-model="filter.countryAndMarket"
        ></gj-country-server-select>
        <gj-select
          v-model="filter.claimStatus"
          type="multi-check"
          width="140px"
          :multiple="true"
          :options="claimStatusOptions"
          placeholder="索赔状态"
        ></gj-select>
        <gj-select-date-picker
          v-model="filter.date"
          type="daterange"
          :options="[
              {id: 'shipment', text: '货件完成日期'},
              {id: 'create', text: '分析时间'},
              {id: 'caseId', text: 'Case填写时间'},
          ]"
          :width="['120px']"
        >
        </gj-select-date-picker>
        <gj-select-input
            v-model="filter.keyword"
            :options="[
              {id: 'shipmentIds', text: '货件号', moreShow: true},
              {id: 'mskus', text: 'MSKU', moreShow: true},
              {id: 'asins', text: 'ASIN', moreShow: true}
            ]"
        ></gj-select-input>
      </app-filter-group>
    </template>

    <template #operate-group>
      <gj-button
        type="primary"
        @click="modifyCaseID(true, null)"
        :disabled="noSelect"
        v-if="$permission('claim:edit')"
      >
        填写CaseID
      </gj-button>
      <gj-button
        :disabled="noSelect"
        @click="modifyStatus(true)"
        v-if="$permission('claim:edit')"
        >更新索赔状态
      </gj-button>
    </template>

    <template #tool-group>
      <gj-tool-group help>
      </gj-tool-group>
    </template>

    <template #table>
      <gj-table
        ref="gjTable"
        :index="false"
        :loading="loading"
        size="has-picture"
        :data="tableData"
        :columns="columns"
        :show-overflow="false"
        selection
        expand
        expand-seize-seat
        :expand-lazy-load="expandLazyLoad"
        :pagination="pagination"
        :default-sort="defaultSort"
        @sort-change="$gjSortChange"
        @page-change="$gjNoticeQuery">
        <template v-slot:marketId="{ row }">
          {{ row.marketId | optionText(marketOption) }}
        </template>
        <template v-slot:shipmentId="{ row }">
          {{row.shipmentId | defaultShow}}
        </template>
        <template v-slot:shipmentTime="{ row }">
          {{row.shipmentTime | formatToDate}}
        </template>
        <template v-slot:createTime="{ row }">
          {{row.createTime | formatToDate}}
        </template>
        <template v-slot:claimStatus="{ row }">
          <gj-tag type="text" :color="getColor(row.claimStatus)">{{ getStatusName(row.claimStatus) }}</gj-tag>
          <span v-if="row.claimStatus === 1 && $permission('claim:edit')" @click="modifyStatus(false, row)" class="copy-icon gj-cell-display-switch refresh-icon-color">
            <gj-icon class="el-icon-refresh"></gj-icon>
          </span>
        </template>
        <template v-slot:memo="{ row }">
          <template v-if="$permission('claim:edit')">
             <ClaimMemoInput
                :value="row.memo"
                :item="row"
                fixedIcon
                table-cell-edit
                :on-confirm="onConfirm"
                :pop-title="'编辑备注'">
            </ClaimMemoInput>
          </template>
          <template v-else>
            <gj-tooltip :content="row.memo" :textLine="1">{{row.memo}}</gj-tooltip>
          </template>
        </template>
        <template v-slot:expand:marketId="{ row }">
          <div class="flex justify-start align-center">
            <gj-image :src="row.imageUrl"></gj-image>
          </div>
        </template>
        <template v-slot:expand:shipmentId="{ row }">
          <div class="flex">
            <span>MSKU：</span>
            <gj-tooltip :content="row.msku" :textLine="1" class="flex1">{{row.msku | defaultShow}}</gj-tooltip>
          </div>
          <div class="flex">
            <span>ASIN：</span>
            <gj-link :disabled="!row.asin" :href="row.asinUrl" target="_blank">{{row.asin | defaultShow}}</gj-link>
          </div>
        </template>
        <template v-slot:expand:shipmentTime="{ row }">
          <div class="flex">
          FNSKU：<gj-tooltip :content="row.fnsku" :textLine="1" class="flex1">{{row.fnsku | defaultShow}}</gj-tooltip>
          </div>
        </template>
        <template v-slot:expand:createTime>
          -
        </template>
        <template v-slot:expand:claimStatus>
          -
        </template>
        <template v-slot:expand:memo>
          -
        </template>
        <template v-slot:op="{ row }">
          <gj-button-group type="dropdown-op">
              <template v-if="$permission('claim:edit')">
                <gj-button type="text" @click="modifyCaseID(false, row)">{{row.caseId ? "修改CaseID" : "填写CaseID"}}</gj-button>
              </template>
            <template  v-if="$permission('claim:edit')">
              <gj-button type="text"  @click="viewTemplate(row)">索赔模板</gj-button>
            </template>
          </gj-button-group>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {queryMixin, selectionMixin, isMeaningfulMixin} from "@/minxins";
  import ClaimInputCase from './modal/shipment-claim-input-case';
  import ClaimCaseTemplate from './modal/shipment-claim-tempate';
  import ClaimMemoInput from '../return-claim/modal/claim-memo-input';
  import {defaultVal, isMeaningful} from '@/utils/common';
  import {getShipmentClaimList, getShipmentClaimTotal, refreshShipmentClaim, getShipmentClaimTemplate, updateShipmentClaim} from '@/api/tool';
  import { tagColors } from '@/components/tag/tag-colors';
  import ClaimTotalHead from '../../components/claim-total-head';
  import { convertToDate } from "@/utils/date.util";
  import {mapGetters} from "vuex";

  export default {
    name: "app-shipment-claim",
    mixins: [queryMixin, selectionMixin,isMeaningfulMixin],
    components: {
      ClaimTotalHead,
      ClaimMemoInput
    },
    computed:{
      ...mapGetters({
        marketOption: "marketOption",
      }),
    },
    data() {
      return {
        totalObj:{},
        tagColors,
        timestamp: null,
        tableData: [],
        columns: [
          {id: 'marketId', header: '店铺/国家', field: 'slot:marketId', minWidth: '130px', fixed: "left"},
          {id: 'shipmentId', header: '货件编号', field: 'slot:shipmentId', minWidth: '160px', fixed: "left"},
          {id: 'shipmentTime', header: '货件完成日期', field: 'slot:shipmentTime', minWidth: '170px', sortable: true, fixed: "left" },
          {id: 'createTime', header: '分析时间', field: 'slot:createTime', minWidth: '105px', sortable: true, help: '系统分析并生成此条索赔建议的时间'},
          {id: 'estimateLostQuantity', header: '丢失商品', field: 'estimateLostQuantity', minWidth: '120px', align: 'right', sortable: true, help: '亚马逊已赔偿的商品不再计入'},
          {id: 'estimateClaimQuantity', header: '预计赔付数量', field: 'estimateClaimQuantity', minWidth: '130px', align: 'right', sortable: true, help: '预计赔付数量=未退回商品+残损商品'},
          {id: 'estimateClaimSingleCost', header: '预计赔付金额', field: 'estimateClaimSingleCost', align: 'right', prefix: "currencySymbol",  minWidth: '130px', sortable: true, help: '按照最近一次赔偿单价计算，最近无赔偿单价为0'},
          {id: 'claimStatus', header: '索赔状态', field: 'slot:claimStatus', minWidth: '100px', help: '在您填写caseID后，10天内系统会每天检测《赔偿》报表，更新索赔状态；如超过10天未索赔成功，则自动判别为索赔失败；您可以手动更新索赔状态'},
          {id: 'caseId', header: 'CaseID', field: 'caseId', minWidth: '140px'},
          {id: 'claimTime', header: 'case填写时间', field: 'claimTime', minWidth: '160px', sortable: true, help: '填写caseID的时间；如修改caseID，则此时间会更新'},
          {id: 'realClaimQuantity', header: '实际赔付库存量', field: 'realClaimQuantity', align: 'right', sortable: true, minWidth: '125px'},
          {id: 'realClaimCashQuantity', header: '实际赔付金额量', field: 'realClaimCashQuantity', align: 'right', sortable: true, minWidth: '125px'},
          {id: 'realClaimMoney', header: '实际赔付金额', field: 'realClaimMoney',  align: 'right', prefix: "currencySymbol", sortable: true, minWidth: '120px'},
          {id: 'memo', header: '备注', field: 'slot:memo', minWidth: '160px', overflowLine: 1},
          {id: 'op ', header: '操作', field: 'slot:op', minWidth: '156px', fixed: 'right', notCustomColumn: true},
        ],
        defaultSort: {prop: '', order: 'descending'},
        filter: {
          claimStatus: [],
          countryAndMarket: null,
          date: {
            key: 'create',
            value: null
          },
          keyword: {
            key: 'shipmentIds',
            value: null,
          }
        },
        claimStatusOptions: [
          {id: 0, text: '未索赔'},
          {id: 1, text: '索赔失败'},
          {id: 2, text: '索赔中'},
          {id: 3, text: '索赔成功'},
          {id: 4, text: '已过期'}
        ],
      }
    },
    methods: {
      defaultVal,
      $gjQueryInitParams() {
        return {
           filter: {
            claimStatus: [],
            countryAndMarket: null,
            date: {
              key: 'create',
              value: null
            },
            keyword: {
              key: 'shipmentIds',
              value: null,
            }
          },
        }
      },
      $gjQuery() {
        this.loading = true;
        let params = {
          model: {
            marketIds: isMeaningful(this.filter.countryAndMarket) ? this.filter.countryAndMarket.marketIds : null,
            countryCodes: isMeaningful(this.filter.countryAndMarket) ? this.filter.countryAndMarket.countryIds : null,
            claimStatus: this.filter.claimStatus,
          },
          ...this.queryPagination,
          ...this.querySort,
        };
        if(isMeaningful(this.filter.date) && isMeaningful(this.filter.date.value)) {
          params.model[this.filter.date.key + 'TimeBegin'] = convertToDate(this.filter.date.value[0]);
          params.model[this.filter.date.key + 'TimeEnd'] = convertToDate(this.filter.date.value[1]);
        }
        if(this.filter.keyword.value){
          params.model[this.filter.keyword.key] = this.filter.keyword.value.split(',');
        }
        getShipmentClaimList(params)
          .then((data) => {
            let tableData = data.records || []
            this.tableData = tableData
            this.pagination = this.getPagination(data);
          }).complete(() => this.loading = false)
        this.getShipmentClaimTotal(params)
      },
      getShipmentClaimTotal(params){
        getShipmentClaimTotal(params).then((data)=>{
          this.totalObj = data;
        });
      },
      expandLazyLoad(row, index, resolve) {
        setTimeout(()=> {
          resolve(row.shipmentItemClaimPageVO || []);
        }, 50)
      },
      onConfirm(memo, data, closeEditor) {
        updateShipmentClaim({id: [data.id], memo: memo})
          .then(() => {
            this.$gjMessage.success('操作成功');
            this.$gjResetPage();
            closeEditor();
          })
      },
      modifyCaseID(batch, row) {
        let props = {}
        if(batch){
          props = {
            id: this.selectedRows.map(item => item.id),
          }
          if (this.selectedRows && this.selectedRows.length == 1) {
            props.caseId = this.selectedRows[0].caseId || '';
          }
        }else{
          props = {
            id: [row.id],
            caseId: row.caseId
          }
        }
        const modal = this.$gjCreate(ClaimInputCase, {
          props: props,
          on: {
            after: () => {
              this.$gjResetPage();
              modal.$gjDestroy();
            }
          }
        })
      },
      viewTemplate(row) {
        getShipmentClaimTemplate(row.id).then((data)=>{
          this.$gjCreate(ClaimCaseTemplate, {
            props: {
              item: row,
              claimTemplate: data
            }
          })
        })
      },
      getColor(status) {
        switch (status) {
          case 0:
            return this.tagColors.violetText;
          case 1:
            return this.tagColors.redText;
          case 2:
            return this.tagColors.orangeText;
          case 3:
            return this.tagColors.greenText;
          case 4:
            return this.tagColors.gray6Text;
        }
      },
      getStatusName(status) {
        let statusName = '-';
        switch (status) {
          case 0:
            statusName = '未索赔';
            break;
          case 1:
            statusName = '索赔失败';
            break;
          case 2:
            statusName = '索赔中';
            break;
          case 3:
            statusName = '索赔成功';
            break;
          case 4:
            statusName = '已过期';
            break;
        }
        return statusName;
      },
      modifyStatus(batch, row){
        let ids = null;
        if(batch){
          const selectedItem =  this.selectedRows || [];
          const selectIds = selectedItem.filter(item => item.claimStatus === 1).map(item => item.id);
          if (selectIds.length == 0) {
            this.$gjMessage.error('当前选中的数据不可更新索赔状态，请选择索赔失败的数据再更新索赔状态');
            return;
          }
          ids = selectIds;
        }else{
          ids = [row.id];
        }
        refreshShipmentClaim(ids).then((data) => {
          if (data){
            this.$gjMessage.success('操作成功！');
            this.$gjQuery();
          }
        });
      },
    },
  }
</script>

<style scoped lang="scss">
/deep/ .vxe-table--render-default .vxe-body--column.col--ellipsis:not(.col--actived) > .vxe-cell {
  width: 100% !important;
}
/deep/ .vxe-table--render-default.size--small .vxe-body--column.col--ellipsis > .vxe-cell {
  max-height: 100%;
}
</style>

